import request from '@/config/axios'
import type { PageParam } from '@/types/common'
import type { PageResult } from '@/api/lawyer'

export interface FirmIntegrationConfigVO {
  id?: number
  enabled?: boolean
  adapterType?: string
  webhookUrl?: string
  webhookSecret?: string
  mappingJson?: string
  retryMax?: number
  remark?: string
  updateTime?: string
}

export interface FirmIntegrationSyncVO {
  id?: number
  bizType?: string
  action?: string
  bizId?: number
  idempotentKey?: string
  status?: string
  payloadJson?: string
  responseBody?: string
  httpStatus?: number
  retryCount?: number
  lastError?: string
  occurredAt?: string
  createTime?: string
}

export interface FirmIntegrationSyncPageReq extends PageParam {
  bizType?: string
  status?: string
  bizId?: number
}

export const FirmIntegrationApi = {
  getConfig: () =>
    request.get<FirmIntegrationConfigVO>({ url: '/lawyer/firm/integration/config/get' }),
  saveConfig: (data: FirmIntegrationConfigVO) =>
    request.put({ url: '/lawyer/firm/integration/config/save', data }),
  syncPage: (params: FirmIntegrationSyncPageReq) =>
    request.get<PageResult<FirmIntegrationSyncVO>>({ url: '/lawyer/firm/integration/sync/page', params }),
  syncGet: (id: number) =>
    request.get<FirmIntegrationSyncVO>({ url: '/lawyer/firm/integration/sync/get?id=' + id }),
  syncRetry: (id: number) =>
    request.put({ url: '/lawyer/firm/integration/sync/retry?id=' + id }),
  testOutbound: () =>
    request.post<FirmIntegrationSyncVO>({ url: '/lawyer/firm/integration/test-outbound' })
}

export const INTEGRATION_ADAPTER_OPTIONS = [
  { value: 'MOCK', label: 'Mock（本地/CI）' },
  { value: 'WEBHOOK', label: 'Webhook' }
]

export const INTEGRATION_SYNC_STATUS_OPTIONS = [
  { value: 'PENDING', label: '待发送' },
  { value: 'SUCCESS', label: '成功' },
  { value: 'FAILED', label: '失败' }
]

export const integrationSyncStatusLabel = (status?: string) =>
  INTEGRATION_SYNC_STATUS_OPTIONS.find((o) => o.value === status)?.label || status || '-'
